import { css } from "styled-components";
import token from "styled-token";
/** @class AccordionPanelMixin */

/** @method */

export var AccordionPanelMixin = function AccordionPanelMixin(props) {
  return token({
    backgroundColor: "AccordionPanel.backgroundColor",
    borderColor: "AccordionPanel.borderColor",
    borderRadius: "AccordionPanel.borderRadius",
    borderSize: "AccordionPanel.borderSize",
    padding: "AccordionPanel.padding"
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
        borderColor = _ref.borderColor,
        borderRadius = _ref.borderRadius,
        borderSize = _ref.borderSize,
        padding = _ref.padding;
    return css(["background-color:", ";border-radius:0 0 ", "px ", "px;border-top:", "px solid ", ";padding:", "px;margin:0;"], backgroundColor, borderRadius, borderRadius, borderSize, borderColor, padding);
  })(props);
};